import {getSVGIcon} from "../../../utilities/globalUtilities";

/**
 * Defines the HTML for modal
 * @param {string} brandID
 */
const defineHTMLForModal = (brandID) => {
    let modalHTML =
        `<div class="modal fade ${brandID}-quick-view-modal" id="quick-view-modal" role="dialog" tabindex="-1" aria-labelledby="quickview-label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered ct-modal-mobile-fullsize ct-modal-size--quickview ${brandID}-modal-dialog quick-view-dialog ${brandID}-quick-view-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title pwc-h3 d-sm-none text-left" id="quickview-label"></h3>
                        <button type="button"
                            class="close pull-right"
                            data-dismiss="modal"
                            aria-label=""
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="">
                            ${getSVGIcon("icon-close-circle-modal")}
                        </button>
                    </div>

                    <div class="modal-body col-12"></div>
                </div>
            </div>
        </div>`;

    return modalHTML;
};

export { defineHTMLForModal };
